<template>
  <validation-provider
    :name="$attrs.title"
    :rules="{required:{ allowFalse: false }}"
  >
    <span class="form-check">
      <span class="form-check-input">
        <input
          :id="id"
          :ref="id"
          v-model="contents"
          :name="name"
          type="checkbox"
          v-bind="$attrs"
          @change="onInput($event.target.checked)"
        >
        <i class="icon"><icon-check /></i>
      </span>
      <label :for="id" class="form-check-text">{{ text }}<small v-if="required" class="required">필수</small></label>
    </span>
  </validation-provider>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    iconCheck: () => import('@/static/svg/check.svg'),
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    contents: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
        return newValue
      }
    }
  },
  mounted () {
  },
  methods: {
    onInput (value) {
      this.contents = value
    },
    onfocus () {
      this.$refs[this.id].focus()
    }
  }
}
</script>
